import type { ReactNode } from 'react';
import type { MeterBucket, RegisterChip } from '@metron/shared';
import { METER_CHIPS, REGISTER_CHIPS } from '@metron/shared';
import { MultiselectFilter } from './MultiselectFilter';

export interface ProductTypeFilterBarProps {
  registerBuckets: RegisterChip[];
  meterBuckets: MeterBucket[];
  onRegisterChange: (values: RegisterChip[]) => void;
  onMeterChange: (values: MeterBucket[]) => void;
  trailing?: ReactNode;
}

export function ProductTypeFilterBar({
  registerBuckets,
  meterBuckets,
  onRegisterChange,
  onMeterChange,
  trailing,
}: ProductTypeFilterBarProps) {
  return (
    <div className='flex flex-wrap items-center gap-2'>
      <MultiselectFilter<RegisterChip>
        label='Register Type'
        options={REGISTER_CHIPS}
        selected={registerBuckets}
        onChange={onRegisterChange}
      />
      <MultiselectFilter<MeterBucket>
        label='Meter Type'
        options={METER_CHIPS}
        selected={meterBuckets}
        onChange={onMeterChange}
      />
      {trailing ? <div className='ml-2'>{trailing}</div> : null}
    </div>
  );
}
